import request from "@/router/axios";

// 获取巡检路线列表
export const getList = (data) => {
  return request({
    url: "/api/produce/inspection-route/select/page",
    method: "post",
    data
  });
};

// 获取巡检路线详情
export const getDetail = (id) => {
  return request({
    url: "/api/produce/inspection-route/select/id",
    method: "get",
    params: { id },
  });
};

// 新增巡检路线
export const add = (data) => {
  return request({
    url: "/api/produce/inspection-route/insert",
    method: "post",
    data,
  });
};

// 更新巡检路线
export const update = (data) => {
  return request({
    url: "/api/produce/inspection-route/update",
    method: "post",
    data,
  });
};

// 删除巡检路线
export const remove = (ids) => {
  return request({
    url: "/api/produce/inspection-route/delete/ids",
    method: "post",
    params: { ids },
  });
};

// 批量更新状态
export const updateStatusBatch = (data) => {
  return request({
    url: "/api/produce/inspection-route/update/status/batch",
    method: "post",
    params: {
      ids: data.ids,
      status: data.status,
    },
  });
};

// 查询拼音码
export const getPinyinList = (data) => {
  return request({
    url: "/api/produce/inspection-route/select/distinct/pycode",
    method: "post",
    data,
  });
};

// 获取点位列表（用于选择点位）
export const getPointList = (params) => {
  return request({
    url: "/api/produce/inspection-point/select/page",
    method: "post",
    data: params,
  });
};

